<nav id="navbar" class="navbar navbar-expand-lg navbar-light" [ngClass]="{'fixed-top':this.fixNavBar}">
  <div class="container-fluid">
    <a *ngIf="false" class="navbar-brand" routerLink="/">
      <img src="assets/imgs/Bhavani_Negro.png" width="140" height="19" alt="Logo" />
    </a>
    <img class="m-auto" src="assets/imgs/Bhavani_Negro.png" width="140" height="19" alt="Logo" />
    <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarScroll"
      aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
      <span class="toggler-icon top-bar"></span>
      <span class="toggler-icon middle-bar"></span>
      <span class="toggler-icon bottom-bar"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarScroll">
      <ul class="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll">
        <li *ngFor="let element of navigation_links; let i = index" data-index="i" class="nav-item ps-3 ps-lg-0">
          <a *ngIf="!element.external" [id]="'buttonHeader' + i" class="nav-link" aria-current="page" [routerLink]="element.path"
            routerLinkActive="active" [state]="element?.routeData">{{ element.name }}</a>
          <a *ngIf="element.external" [id]="'buttonHeader' + i" class="nav-link" aria-current="page" [href]="element.path">{{ element.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</nav>